import { useEffect } from 'react';

// Context
import { useGlobalState } from '@wearetla/tla-essentials-tools/utilities/global-state';

// Services
import eventServices from '/services/event';
import siteServices from '/services/site';

const getHighlightedEvents = () => siteServices.getShowcase('HOME_TOP_FIVE');

const getPrimaryEvent = () => eventServices.getPrimaryEvent();

const getBanners = () => siteServices.getBanners(1);

export const GlobalStateController = () => {
	const { highlightedEvents, banners, primaryEvent, setData } = useGlobalState();

	// CSR fallback.
	useEffect(() => {
		if (!highlightedEvents) {
			getHighlightedEvents()
				.then((highlightedEvents) => {
					setData('highlightedEvents', highlightedEvents);
				})
				.catch(() => {});
		}
	}, [highlightedEvents]);

	useEffect(() => {
		if (!banners) {
			getBanners()
				.then((banners) => {
					setData('banners', banners);
				})
				.catch(() => {});
		}
	}, [banners]);

	useEffect(() => {
		if (!primaryEvent) {
			getPrimaryEvent()
				.then((primaryEvent) => {
					setData('primaryEvent', primaryEvent);
				})
				.catch(() => {});
		}
	}, [primaryEvent]);

	return null;
};

GlobalStateController.getServerProps = () => {
	return new Promise((resolve) => {
		Promise.all([
			getHighlightedEvents().catch((e) => {
				console.error('Initial props error - getHighlightedEvents', e);
				return null;
			}),
			getBanners().catch((e) => {
				console.error('Initial props error - getBanners', e);
				return null;
			}),
			getPrimaryEvent().catch((e) => {
				console.error('Initial props error - getPrimaryEvent', e);
				return null;
			}),
		])
			.then(([
				highlightedEvents,
				banners,
				primaryEvent,
			]) => {
				resolve({
					highlightedEvents,
					banners,
					primaryEvent,
				});
			});
	});
};